export default "__VITE_ASSET__o$kRO$Lt__"